(function () {
  if (window.__jarvisMotionLoaded) return;
  window.__jarvisMotionLoaded = true;

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function addRevealTargets() {
    const selectors = [
      '.cozy-editorial-hero__copy',
      '.cozy-editorial-hero__stack',
      '.cozy-editorial-hero__card',
      '.cozy-editorial-hero__accent',
      '.product-list .section-header',
      '.collection-links .section-header',
      '.custom-liquid .section-header',
      '.product-card',
      '.collection-card'
    ];

    document.querySelectorAll(selectors.join(',')).forEach(function (el, index) {
      if (!el.hasAttribute('data-jarvis-reveal')) {
        el.setAttribute('data-jarvis-reveal', '');
        const delay = Math.min((index % 8) * 0.05, 0.28);
        el.style.setProperty('--jarvis-delay', delay + 's');
      }
    });

    document.querySelectorAll('.cozy-editorial-hero__card, .cozy-editorial-hero__accent').forEach(function (el) {
      el.setAttribute('data-jarvis-float', '');
    });
  }

  function observeReveals() {
    const targets = document.querySelectorAll('[data-jarvis-reveal]');
    if (!targets.length) return;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' });

    targets.forEach(function (el) { observer.observe(el); });
  }

  function bindFloatCards() {
    if (prefersReduced) return;

    document.querySelectorAll('[data-jarvis-float]').forEach(function (el) {
      if (el.dataset.jarvisFloatBound === 'true') return;
      el.dataset.jarvisFloatBound = 'true';

      el.addEventListener('mousemove', function (event) {
        const rect = el.getBoundingClientRect();
        const px = (event.clientX - rect.left) / rect.width;
        const py = (event.clientY - rect.top) / rect.height;
        const rotateY = (px - 0.5) * 8;
        const rotateX = (0.5 - py) * 8;
        const moveX = (px - 0.5) * 6;
        const moveY = (py - 0.5) * -6;
        el.style.setProperty('--jarvis-rotate-y', rotateY.toFixed(2) + 'deg');
        el.style.setProperty('--jarvis-rotate-x', rotateX.toFixed(2) + 'deg');
        el.style.setProperty('--jarvis-move-x', moveX.toFixed(2) + 'px');
        el.style.setProperty('--jarvis-move-y', moveY.toFixed(2) + 'px');
      });

      el.addEventListener('mouseleave', function () {
        el.style.setProperty('--jarvis-rotate-y', '0deg');
        el.style.setProperty('--jarvis-rotate-x', '0deg');
        el.style.setProperty('--jarvis-move-x', '0px');
        el.style.setProperty('--jarvis-move-y', '0px');
      });
    });
  }

  function init() {
    document.body.classList.add('jarvis-motion-enabled');
    addRevealTargets();
    observeReveals();
    bindFloatCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
